import React from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import { Button, FormGroup, Input, Label } from 'reactstrap';
import api from '../../../api';
import './index.css';

// const datasource_configs = [
//   'datasource_host',
//   'datasource_port',
//   'datasource_user',
//   'datasource_secret',
//   'datasource_schema_name',
// ]
export default class BigQueryDatasource extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isCreateNew: this.props.isCreateNew || false,
      datasource: this.props.datasource || {
        name: '',
        code_name: '',
        description: '',
        datasource_type: 'bigquery',
        extra_data: {},
        datasource_host: '',
        datasource_port: '',
        datasource_user: '',
        datasource_secret: '',
        datasource_schema_name: '',
      }
    };
  }
  updateAttr(attribute, value) {
    const { datasource } = this.state;
    datasource[attribute] = value;
    this.setState({ datasource });
  }
  updateExtraAttr(attribute, value) {
    const { datasource } = this.state;
    datasource.extra_data[attribute] = value;
    this.setState({ datasource });
  }
  updateDatasource() {
    const { datasource, isCreateNew } = this.state;
    const { onDatasourceUpdated } = this.props;
    delete datasource.object_type;
    delete datasource.databases;

    api.fetchAPI({
      method: isCreateNew ? 'post' : 'put',
      uri: 'datasources',
      body: datasource,
      success: (response) => {
        if (response.status === 'ok') {
          this.setState({ datasource: response.datasource });
          alert('Datasource is saved');
          if (onDatasourceUpdated) {
            onDatasourceUpdated(response.datasource);
          }
        } else {
          alert('Fail to create new datasource');
        }
      },
      error: (error) => {
        console.error(error);
      }
  });
  }
  render() {
    const { datasource, isCreateNew } = this.state;
    return (
      <div className="">
        <h5>BigQuery</h5>
        <p>
          Instruction: You need to upload your Google Cloud service account JSON key file to <b>backend/app/connector_properties</b> directory
          and restart DataDex service
        </p>
        <FormGroup>
          <Label>Code name</Label>
          <Input
            type="text"
            value={datasource.code_name}
            placeholder="my-data-source-bigquery"
            onChange={(e) => this.updateAttr('code_name', e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <Label>Name</Label>
          <Input
            type="text"
            value={datasource.name}
            placeholder="Apex bigquery datasource"
            onChange={(e) => this.updateAttr('name', e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <Label>Description</Label>
          <TextareaAutosize
            className="form-control"
            type="textarea"
            value={datasource.description}
            placeholder="Love you to the moon and back"
            onChange={(e) => this.updateAttr('description', e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <Label>Google Cloud Project ID</Label>
          <Input
            type="text"
            value={datasource.datasource_host}
            placeholder="i-am-iron-man"
            onChange={(e) => this.updateAttr('datasource_host', e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <Label>Service account key file name</Label>
          <Input
            type="text"
            value={datasource.datasource_secret}
            placeholder="google-account-key.json"
            onChange={(e) => this.updateAttr('datasource_secret', e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <Label>Ignored datasets (comma seperated)</Label>
          <TextareaAutosize
            className="form-control"
            type="textarea"
            placeholder="dataset1, dataset2, dataset3..."
            value={datasource.extra_data.ignored_datasets}
            onChange={(e) => this.updateExtraAttr('ignored_datasets', e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <Button
            color="success"
            onClick={() => this.updateDatasource()}
          >
            {isCreateNew ? 'Create' : 'Save'}
          </Button>
        </FormGroup>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/connectors/BigQuery/index.js